<div class="row">
  <div class="col-lg-6">
    <h2 class="wow pulse" data-wow-iteration="2" data-wow-duration="0.2">The Wellness and Preventive Care</h2>
  </div>
  <div class="col-lg-6">
    <p style="max-width: 500px">
      Safari Wellness Plans are tailored to meet the needs of all creatures
      great and small as well as the needs of your pocketbook.
    </p>
  </div>
</div>
<div #swiperContainer class="swiper-container overflow-hidden position-relative">
  <div class="swiper-wrapper">
    @for (plan of plans; track $index) {

    <div class="swiper-slide">
      <div class="row">
        <div class="col-xxl-6 col-xl-7 col-lg-7 order-lg-1 order-2">
          <div class="contain-box">
            <hr class="my-5 d-none d-lg-block" />
            <h5 class="mb-4">{{ plan?.name | titlecase }}</h5>
            <p class="mb-5" [innerHTML]="plan?.description | safeHtml"></p>

            @if(plan.LowestPlanLevel){
            <p class="text-success">
              Plan starts with
              <span>{{ plan?.LowestPlanLevel?.monthly_price | currency }}</span>
            </p>
            } @if(plan?.review?.total_review > 0){
            <p>
              <app-star-rating [maxScore]="5" [score]="plan?.review?.ratting" [forDisplay]="true"></app-star-rating>
              &nbsp;{{ plan?.review?.total_review }}
            </p>
            }

            <div class="d-flex justify-content-between align-items-center position-relative">
              @if(plan?.LowestPlanLevel){
              <button class="btn btn-success" (click)="goToPlan(plan)">
                Visit Plans
              </button>
              }
              <div class="swiper-button-prev" (click)="onSlidePrev()"></div>
              <div class="swiper-button-next" (click)="onSlideNext()"></div>
            </div>
          </div>
        </div>
        <div class="col-xxl-6 col-xl-5 col-lg-5 order-lg-2 order-1">
          <div class="img-box text-center text-lg-righ">
            <img [src]="filePath + plan.id + '/cover_image/' + plan.cover_image_2" alt="" class="rounded-5"
              onerror="this.src='/assets/images/default_subscription.png'" />
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>